import { Link } from 'react-router-dom';
import { Linkedin, Twitter } from 'lucide-react';
import { useLang } from '../../context/LangContext';

const LOGO_URL = process.env.PUBLIC_URL + "/logo.png";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="footer" className="border-t border-white/[0.05] bg-[#020209] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Col 1 - Brand */}
          <div>
            <img src={LOGO_URL} alt="AIpreneur" className="h-10 mb-4" />
            <p className="text-neutral-300 text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="mt-4 text-xs text-neutral-500">
              <p>{t("footer.powered")}</p>
            </div>
          </div>

          {/* Col 2 - Navigation */}
          <div>
            <p className="uppercase text-xs text-neutral-500 tracking-[0.08em] font-medium mb-4">
              {t("footer.nav")}
            </p>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-neutral-400 hover:text-white transition-colors">{t("footer.home")}</Link>
              <Link to="/agent" className="text-sm text-neutral-400 hover:text-white transition-colors">{t("nav.agentia")}</Link>
              <Link to="/secteurs" className="text-sm text-neutral-400 hover:text-white transition-colors">{t("nav.sectors")}</Link>
              <Link to="/tarifs" className="text-sm text-neutral-400 hover:text-white transition-colors">{t("nav.pricing")}</Link>
              <Link to="/contact" className="text-sm text-neutral-400 hover:text-white transition-colors">{t("nav.contact")}</Link>
            </nav>
          </div>

          {/* Col 3 - Zones couvertes */}
          <div>
            <p className="uppercase text-xs text-neutral-500 tracking-[0.08em] font-medium mb-4">
              {t("footer.zones.title")}
            </p>
            <p className="text-sm text-neutral-400 leading-relaxed">
              {t("footer.zones")}
            </p>
          </div>

          {/* Col 4 - Legal + Social */}
          <div>
            <p className="uppercase text-xs text-neutral-500 tracking-[0.08em] font-medium mb-4">
              {t("footer.legal.title")}
            </p>
            <nav className="flex flex-col gap-3 mb-6">
              <Link to="/mentions-legales" className="text-sm text-neutral-400 hover:text-white transition-colors">
                {t("footer.mentions")}
              </Link>
              <Link to="/confidentialite" className="text-sm text-neutral-400 hover:text-white transition-colors">
                {t("footer.privacy")}
              </Link>
            </nav>
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-neutral-600 hover:text-white transition-colors" data-testid="footer-linkedin">
                <Linkedin size={18} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-neutral-600 hover:text-white transition-colors" data-testid="footer-twitter">
                <Twitter size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/[0.03] pt-8 mt-12 text-center">
          <p className="text-xs text-neutral-600">{t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
};
